<div class="lp-page">

  <div class="lp-header">
    <h1 class="lp-title">{{ 'MY_PLATES.TITLE' | translate }}</h1>
    @if (plates().length > 0 && !IsJKUUser()) {
    <jjames-button variant="primary" size="sm" matIconLeft="add" (clicked)="addPlate()">
      {{ 'MY_PLATES.ADD' | translate }}
    </jjames-button>
    }
  </div>

  @if (errorText(); as text) {
  <div class="lp-error">{{ text }}</div>
  } @else if (errorKey(); as key) {
  <div class="lp-error">{{ key | translate }}</div>
  }

  @if (isLoading()) {
  <div class="lp-loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  } @else if (plates().length === 0) {
  <div class="lp-empty">
    <mat-icon class="lp-empty__icon">directions_car</mat-icon>
    <p class="lp-empty__text">{{ 'MY_PLATES.EMPTY' | translate }}</p>
    <jjames-button variant="primary" matIconLeft="add" (clicked)="addPlate()">
      {{ 'MY_PLATES.ADD_FIRST' | translate }}
    </jjames-button>
  </div>
  } @else {
  <div class="lp-list">
    @for (row of plateRows(); track row.licensePlateId) {
    <div class="lp-item">
      <app-plate [number]="row.fullNumber" [euBand]="row.euBand" [countryCode]="row.countryCode"
        [region]="row.region" [regionSeparator]="row.regionSeparator" />
      <span class="lp-spacer"></span>
      <jjames-button variant="action-delete" size="sm" matIconLeft="delete"
        [loading]="removingId() === row.licensePlateId" (clicked)="remove(row.source)">
        {{ 'MY_PLATES.REMOVE' | translate }}
      </jjames-button>
    </div>
    }
  </div>
  }

</div>
